// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const ArrowUpLongSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M6.54.375A.995.995 0 005.76 0H4.24a.996.996 0 00-.78.375L.61 3.938l.78.624L4.24 1h.26v9h1V1h.26l2.85 3.563.78-.625L6.54.374z" />
    </svg>
  )
}
